"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualProviders = void 0;
exports.ManualProviders = {
    BeurerBle: "beurer_ble",
    OmronBle: "omron_ble",
    AccuchekBle: "accuchek_ble",
    ContourBle: "contour_ble",
    FreestyleLibreBle: "freestyle_libre_ble",
    OnetouchBle: "onetouch_ble",
    AppleHealthKit: "apple_health_kit",
    Manual: "manual",
    HealthConnect: "health_connect",
};
